import * as React from 'react';
import { useIntl } from 'react-intl';
import { saveAs } from 'file-saver';
import ApiService from '../../Services/ApiService';
import { URL_REPORTS, URL_REPORT_DOWNLOAD } from '../../router/constants';
import PageHeader from '../PageHeader';

function EmailDownload(): JSX.Element | null {
  const { formatMessage: f } = useIntl();
  const [is404, setIs404] = React.useState<boolean>(false);

  const toReports = () => {
    localStorage.activeMenuParentId = 11;
    localStorage.activeMenuId = 27;
    return URL_REPORTS;
  };

  const downloadExport = async (signal?: AbortSignal) => {
    const path = window.location.pathname;
    const pathArr = path.split('/');
    let jobId: string | null = null;
    if (pathArr.length === 4) {
      jobId = pathArr[3];
    }
    if (jobId) {
      const response = await ApiService.download(`${URL_REPORT_DOWNLOAD}/${jobId}`, '', signal);
      if (response && response.status === 200) {
        setIs404(false);
        const content = response.headers['content-disposition'];
        if (content) {
          const contentArr = content.split('"');
          let fileName = '';
          if (contentArr.length === 3) {
            fileName = contentArr[1];
          }
          let format = '';
          if (fileName) {
            const fileArr = fileName.split('.');
            if (fileArr.length > 1) {
              format = fileArr[fileArr.length - 1];
            }
            const mimeType =
              format === 'xlsx'
                ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                : 'application/octet-stream';

            const blob = new Blob([response.data], { type: mimeType });
            saveAs(blob, fileName);
          } else {
            setIs404(true);
          }
        } else {
          setIs404(true);
        }
      } else {
        setIs404(true);
      }
    }
  };

  React.useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    downloadExport(signal);
  }, []);

  return is404 ? (
    <>
      <PageHeader title="404 Error" />
      <div className="w-page">
        <div className="w-page-content">
          <div className="w-error w-error--404 d-flex align-items-center">
            <div className="container-fluid">
              <div className="b-error">
                <div className="p-6">
                  <h3 className="b-error-title">{f({ id: 'reports.oops' })}</h3>
                  <h4 className="b-error-subtitle">{f({ id: 'reports.expired' })}</h4>
                  <div className="b-error-text">{f({ id: 'reports.deactivated' })}</div>
                </div>

                <div className="b-error-footer">
                  <a href={toReports()} className="e-button e-button--gray">
                    {f({ id: 'loginForm.login' })}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  ) : null;
}

export default EmailDownload;
